import React, { useCallback, useState } from 'react';
import styled from "styled-components";
import { deviceMax } from "../../../styles/deviceSizes";
import Title from './Title';
import LoginForm from './LoginForm';
import Link from '../../organisms/login/Link';
import ServerValidationErrorAlert from '../../organisms/ServerValidationErrorAlert';
import { ValidationErrorResponse } from '../../../services/ValidationError';
import { generarRuta } from '../../../services/divertidogsApiUtils';


const LoginSection = () => {
    const [serverFailedValidations, setServerFailedValidations] = useState({} as ValidationErrorResponse);

    const iniciarGoogleOAuth = useCallback(() => {
        window.location.href = generarRuta("oauth2/authorization/google");
    }, []);

    return (
        <WrapperLogin className="p-4 p-md-5">
            <div className="d-flex">
                <TitleContainer className="w-100">
                    <Title className="mb-4">Inicio de Sesión</Title>
                </TitleContainer>
            </div>
            
            <ServerValidationErrorAlert serverFailedValidations={serverFailedValidations} />

            <LoginForm setServerFailedValidations={setServerFailedValidations} />
            <SeparadorO>o</SeparadorO>
            <BotonGoogle
                type="button"
                onClick={iniciarGoogleOAuth}
                aria-label="Continuar con Google"
            >
                Continuar con Google
            </BotonGoogle>
            <p className="text-center">¿Aún no es miembro? <Link data-toggle="tab" href="/registro">Regístrese</Link></p>
        </WrapperLogin>
    );
}

const WrapperLogin = styled('div')`
    position: relative;
    background: white;
    width: 50%;
	@media only screen and ${deviceMax.md}{
        width: 100%;
    }
    
`

const TitleContainer = styled('div')`
    text-align: center;
`

const SeparadorO = styled('div')`
    text-align: center;
    margin: 1rem 0;
    color: #6c757d;
    font-size: 0.9rem;
`

const BotonGoogle = styled('button')`
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #dadce0;
    border-radius: 4px;
    background: white;
    color: #3c4043;
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    transition: background 0.2s;

    &:hover {
        background: #f8f9fa;
    }

    &:focus-visible {
        outline: 2px solid #1a73e8;
        outline-offset: 2px;
    }
`

export default LoginSection;